import Base64 from 'crypto-js/enc-base64';
import Utf8 from 'crypto-js/enc-utf8';
import AES from 'crypto-js/aes';

export class BaseModel {
    encryptionKeys;

    constructor(keys) {
        this.encryptionKeys = keys;
    }

    encryptionBase64 = (baseModel, soureModel) => {
        let keys = Object.keys(baseModel);
        const props = this;

        keys.forEach(key => {
            if (props.encryptionKeys.indexOf(key) > -1) {
                baseModel[key] = Base64.stringify(Utf8.parse(JSON.stringify(soureModel[key])));
            }
            else {
                baseModel[key] = soureModel[key];
            }
        });

        return baseModel;
    };

    decryptionBase64 = (baseModel, soureModel) => {
        let keys = Object.keys(baseModel);
        const props = this;

        keys.forEach(key => {
            if (props.encryptionKeys.indexOf(key) > -1) {
                baseModel[key] = JSON.parse(Utf8.stringify(Base64.parse(soureModel[key])));
            }
            else {
                baseModel[key] = soureModel[key];
            }
        });

        return baseModel;
    };

    encryptionAES = (baseModel, soureModel) => {
        let keys = Object.keys(baseModel);
        const props = this;

        keys.forEach(key => {
            if (props.encryptionKeys.indexOf(key) > -1) {
                baseModel[key] = AES.encrypt(soureModel[key], 'secret key 123').toString();
            }
            else {
                baseModel[key] = soureModel[key];
            }
        });

        return baseModel;
    };

    decryptionAES = (baseModel, soureModel) => {
        let keys = Object.keys(baseModel);
        const props = this;

        keys.forEach(key => {
            if (props.encryptionKeys.indexOf(key) > -1) {
                baseModel[key] = AES.decrypt(soureModel[key], 'secret key 123').toString(Utf8);
            }
            else {
                baseModel[key] = soureModel[key];
            }
        });

        return baseModel;
    };

    encryption = (baseModel, soureModel) => {

        return this.encryptionBase64(baseModel, soureModel);
    };

    decryption = (baseModel, soureModel) => {

        return this.decryptionBase64(baseModel, soureModel);
    };
}
